import { createSlice } from '@reduxjs/toolkit';

import { initialState, dashboardAdapter } from './dashboard.state';
import {
  absencesReducers,
  calendarReducers,
  dashboardDetailReducers,
  electronicServicesReducers,
  personalLinksReducers,
  quickActionsReducers,
  externalReducers,
  partitionsReducers,
  taskListReducers,
  widgetsReducers,
  bannerReducers,
  PersonalLinksSettingsReducers,
  newsListReducers,
  newsWidgetSettingsReducers,
  surveysReducers,
  topNewsReducers,
  quickActionsSettingsReducers,
  feedListReducers,
  birthdaysReducers,
} from './actions';

const dashboard = createSlice({
  name: 'dashboard',
  initialState: dashboardAdapter.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    absencesReducers(builder);
    dashboardDetailReducers(builder);
    electronicServicesReducers(builder);
    personalLinksReducers(builder);
    quickActionsReducers(builder);
    newsListReducers(builder);
    externalReducers(builder);
    calendarReducers(builder);
    partitionsReducers(builder);
    taskListReducers(builder);
    widgetsReducers(builder);
    PersonalLinksSettingsReducers(builder);
    newsWidgetSettingsReducers(builder);
    bannerReducers(builder);
    surveysReducers(builder);
    topNewsReducers(builder);
    quickActionsSettingsReducers(builder);
    feedListReducers(builder);
    birthdaysReducers(builder);
  },
});

export const dashboardReducer = dashboard.reducer;
